import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "col-l-12 col-m-12 col-12 gdwrapper container-fluid" };
const _hoisted_2 = { class: "status col-l-12 col-m-12 col-12 gdwrapper" };
const _hoisted_3 = {
    key: 0,
    class: "col-l-12 col-m-12 col-12"
};
const _hoisted_4 = {
    key: 1,
    class: "signIn col-l-6 col-m-6 col-6"
};
const _hoisted_5 = {
    key: 2,
    class: "signIn col-l-6 col-m-6 col-6"
};
const _hoisted_6 = { class: "signOut col-l-6 col-m-6 col-6" };
import { processSignInResponse, signInRedirect, signOutRedirect } from '@/libs/usermanagement';
import { onMounted } from 'vue';
import { useUserStore } from '@/libs/stores';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginView',
    setup(__props) {
        const userStore = useUserStore();
        console.log(userStore.user?.app);
        onMounted(async () => {
            if (!(userStore.user?.auth)) {
                await processSignInResponse();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "top col-l-12 col-m-12 col-12" }, "Top for user information and errors", -1)),
                _createElementVNode("div", _hoisted_2, [
                    ((_unref(userStore).user?.sub !== null && _unref(userStore).user?.app === false))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
                            _createElementVNode("p", null, " Thank you for siging up. ", -1),
                            _createElementVNode("p", null, " Once your account has been approved, you will be able to demo the Song Registration Data Entry form. ", -1)
                        ])))
                        : _createCommentVNode("", true),
                    (!_unref(userStore).user?.sub)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("button", {
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(signInRedirect)()))
                            }, "Sign In")
                        ]))
                        : _createCommentVNode("", true),
                    (_unref(userStore).user?.sub)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Welcome to Coda"))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = ($event) => (_unref(signOutRedirect)()))
                        }, "Sign Out")
                    ])
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "requests col-l-6 col-m-6 col-12" }, "Requests", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "messages col-l-6 col-m-6 col-12" }, "Messages", -1))
            ]));
        };
    }
});
